
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/forgotPassword",
      function () {
        return require("private-next-pages/auth/forgotPassword.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/forgotPassword"])
      });
    }
  